import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, Switch } from 'react-router';
import './App.css';
import { isUserLoggedIn } from './actions/auth';
import { store } from './store';

import About from './components/pages/About';
import ApiIndex from './components/pages/api/Index'
import MoreIndex from './components/pages/more/Index'
import Contact from './components/pages/Contact';
import Home from './components/Home';
import Login from './components/user/Login';
import ScrollToTop from './components/ScrollToTop';
import Access from './components/pages/Access';
import Engage1 from './components/pages/landing/Engage1';
import Register from './components/pages/Register';
import Request from './components/pages/Request';
import Confirm from './components/pages/Confirm';
import Terms from './components/pages/Terms';

store.dispatch(isUserLoggedIn());

class PrivateRouteContainer extends React.Component {
  render() {
    const {
      auth,
      component: Component,
      ...props
    } = this.props

    return (
      <Route
        {...props}
        render={props =>
          auth.get('user').get('isLoggedIn')
            ? <Component {...props} />
            : (
            <Redirect to={{
              pathname: '/',
              state: { from: props.location }
            }} />
          )
        }
      />
    )
  }
}

const PrivateRoute = connect(state => ({
  auth: state.auth
}))(PrivateRouteContainer);

const ConnectedSwitch = connect(state => ({
  location: state.location
}))(Switch);

export default class App extends Component {
  componentDidMount() {
    if (window.location.hostname !== 'localhost') {
      window.dataLayer = window.dataLayer || [];
      function gtag(){window.dataLayer.push(arguments);}
      gtag('js', new Date());

      gtag('config', 'UA-122069684-1');

      document.addEventListener('click',function(e){
        if(e.target.matches('[type="submit"]')){
          gtag('event', 'click', {
            'event_category' : 'button',
            'event_label' : 'Create Account'
          });
        }
      });
    }
  }

  render() {
    return (
      <ConnectedSwitch>
        <Route exact path="/" component={Home} />
        <Route path="/access" component={Access} />
        <Route path="/engage1" component={Engage1} />
        <Route path="/register" component={Register} />
        <Route path="/request" component={Request} />
        <Route path="/about" component={About} />
        <Route path="/contact" component={Contact} />
        <Route path="/login" component={Login} />
        <Route path="/api" component={ApiIndex} />
        <Route path="/more" component={MoreIndex} />
        <Route path="/confirm" component={Confirm} />
        <Route path="/terms" component={Terms} />
      </ConnectedSwitch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js